import React, { FC } from 'react';
import { LocationInfoFieldsProps } from './LocationInfoFieldsProps';

import CustomInput from '../../../common/CustomInput';
import useTranslation from '../../../hooks/useTranslation';
import LocationInfoCountrySelect from '../LocationInfoCountrySelect';
import BUInput from '../BUInputs';

const LocationInfoFields: FC<LocationInfoFieldsProps> = ({
  countries,
  locationName,
  buCode,
  buCodeRequired,
  BUList,
  onBUChange,
  isep,
  isEdit,
  onCountryChange = () => {
    console.log('onCountryChange');
  },
}) => {
  const t = useTranslation();

  return (
    <>
      <LocationInfoCountrySelect
        countries={countries}
        onCountryChange={onCountryChange}
        disabled={isep}
      />
      {buCode && (
        <BUInput
          BuList={BUList}
          onBUChange={onBUChange}
          required={buCodeRequired}
          disabled={isep}
          isEdit={isEdit}
        />
      )}
      <CustomInput
        name={'city'}
        label={t('ppm.columns.city')}
        helperText={t('labels.examplePlaceholderCity')}
        dataTestID={'city'}
      />
      <CustomInput
        name={'state'}
        label={t('labels.state')}
        helperText={t('labels.examplePlaceholderState')}
        dataTestID={'state'}
      />
      <CustomInput
        name={'address'}
        label={t('labels.address')}
        dataTestID={'address'}
      />
      {locationName && (
        <CustomInput
          name={'locationName'}
          label={t('projects.properties.businessUnitFullName')}
          helperText={t('labels.examplePlaceholderLocation')}
          dataTestID={'location-name'}
        />
      )}
    </>
  );
};

export default LocationInfoFields;
